module.exports = __webpack_public_path__ + "img/advanced-char-controls.7da12bcf.png";